import { render, staticRenderFns } from "./digitalHumanRecord.vue?vue&type=template&id=2767c27a&scoped=true"
import script from "./digitalHumanRecord.vue?vue&type=script&lang=js"
export * from "./digitalHumanRecord.vue?vue&type=script&lang=js"
import style0 from "./digitalHumanRecord.vue?vue&type=style&index=0&id=2767c27a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2767c27a",
  null
  
)

export default component.exports